
/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import { FLOW_DEF_VERSION_ID_DEVELOPMENT } from './FlowDefVersionType';


export default declareEntity({
    entity: "libraryDefs",
    graphQL: "LibraryDef",
    name: "Library Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    defaultOrder: ['name'],
    isPublic: true,
    defaultTitle: (data) => {
        return data['name'];
    },
    fields: (types) => { return {
        id: {
            name: "Library Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            isPublic: true,
            required: true,
            userEditable: false,
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            filterable: true,
            trim: true,
        },
        name: {
            name: "Name",
            trim: true,
            type: "string",
            translatable: true,
            filterable: true,
            defaultValue: "",
        },
        description: {
            name: "Library Description",
            type: "text",
            translatable: true,
            defaultValue: "",
        },
        hasChange: {
            name: "Has Change",
            type: "boolean",
            filterable: true,
            export: false,
            import: false,
            userEditable: false,
            isPublic: false,
            permission: Permission.PERM_DEVELOPER,
        },
        libraryDefVersion: {
            name: "Library Definition Version",
            to: () => types['libraryDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['libraryDefVersion_id'] || FLOW_DEF_VERSION_ID_DEVELOPMENT;
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        script: {
            name: "Script",
            type: "javascript",
            defaultValue: "",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        testScript: {
            name: "Test Script",
            type: "javascript",
            defaultValue: "",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        changeAuthor: {
            name: "Last change author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        changeAuthorName: {
            name: "Change Author Name",
            type: "string",
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
        libraryDefMarkdownDocs: {
            type: 'oneToMany',
            to: types['libraryDefMarkdownDocs'],
            export: true,
            defaultValue: () => {
                return {};
            },
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        libraryDefVersions: {
            type: 'oneToMany',
            to: types['libraryDefVersions'],
            export: false,
            permission: Permission.PERM_INSTANCE_ADMIN,
            foreignKeys: [
                {
                    from: "id",
                    to: "libraryDef_id"
                }
            ]
        },
    }; }
});
